module.exports = __webpack_public_path__ + "img/share-variant.914bf02.svg";